import React from "react";
import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import LoadingImage from "./loading_image";

function ConfirmModal({
  confirmYes,
  confirmYesText = "Ok",
  confirmYesButtonClassName = "",
  confirmNo,
  confirmNoText = "Cancel",
  confirmNoButtonClassName = "",
  className = "",
  modalBodyClassName = "",
  modalFooterClassName = "",
  confirmHeaderContent,
  confirmContent,
  isOpening = false,
  isSubmitting = false,
}) {
  let modalHeader;
  let okButton;
  let noButton;

  if (confirmYes) {
    if (isSubmitting) {
      okButton = <LoadingImage height="36" />;
    } else {
      okButton = (
        <Button variant="primary" onClick={() => confirmYes()} className={`btn-confirm ${confirmYesButtonClassName}`}>
          {confirmYesText}
        </Button>
      );
    }
  }

  if (confirmNo) {
    noButton = (
      <button type="button" onClick={() => confirmNo()} className={`btn ${confirmNoButtonClassName}`}>
        {confirmNoText}
      </button>
    );
  }

  if (confirmHeaderContent) {
    modalHeader = <Modal.Header>{confirmHeaderContent}</Modal.Header>;
  }

  return (
    <Modal show={isOpening} className={className}>
      {modalHeader}
      <Modal.Body className={modalBodyClassName}>{confirmContent}</Modal.Body>
      <Modal.Footer className={modalFooterClassName}>
        {okButton}
        {noButton}
      </Modal.Footer>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  className: PropTypes.string,
  confirmContent: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  confirmHeaderContent: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  confirmNo: PropTypes.func,
  confirmNoButtonClassName: PropTypes.string,
  confirmNoText: PropTypes.string,
  confirmYes: PropTypes.func,
  confirmYesButtonClassName: PropTypes.string,
  confirmYesText: PropTypes.string,
  isOpening: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  modalBodyClassName: PropTypes.string,
  modalFooterClassName: PropTypes.string,
};

export default ConfirmModal;
